import { apiPath } from '../../../config';
import { axiosInstance } from '../AxiosInstance';

export const getAllIngredients = async () => {
  return axiosInstance.get(apiPath.ingredients);
};

export const createIngredient = async (payload) => {
  return axiosInstance.post(apiPath.ingredients, payload);
};

export const updateIngredient = async ({ id, payload }) => {
  return axiosInstance.patch(`${apiPath.ingredients}/${id}`, payload);
};

export const deleteIngredient = async (id) => {
  return axiosInstance.delete(`${apiPath.ingredients}/${id}`);
};
